var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGauge2(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 128,
    viewBox: "0 0 207 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5839 5.61703C68.1528 6.08014 67.3681 7.61569 67.8312 9.04679C68.2943 10.4779 69.8298 11.2626 71.2609 10.7995C91.4293 4.27299 113.152 4.33863 133.281 10.9869C134.709 11.4587 136.249 10.6832 136.721 9.25495C137.193 7.82668 136.417 6.28641 134.989 5.81466C113.762 -1.19651 90.8532 -1.26574 69.5839 5.61703ZM139.556 10.1572C140.162 8.78035 141.769 8.15504 143.146 8.76057C163.609 17.7601 180.676 33.0425 191.871 52.3927C192.624 53.6946 192.179 55.3607 190.877 56.114C189.575 56.8672 187.909 56.4224 187.156 55.1205C176.54 36.7719 160.357 22.2805 140.953 13.7468C139.576 13.1412 138.951 11.5341 139.556 10.1572ZM192.193 58.4345C193.556 57.7964 195.177 58.3833 195.815 59.7454C205.299 79.9894 208.089 102.727 203.783 124.664C203.493 126.14 202.061 127.101 200.585 126.812C199.109 126.522 198.148 125.09 198.437 123.614C202.521 102.813 199.875 81.2523 190.882 62.0562C190.244 60.6941 190.831 59.0726 192.193 58.4345ZM13.344 55.5445C12.0507 54.7764 11.6249 53.1054 12.3929 51.8121C23.8078 32.5908 41.0471 17.5039 61.6121 8.73816C62.9958 8.14836 64.5956 8.79195 65.1854 10.1757C65.7752 11.5594 65.1316 13.1592 63.7479 13.749C44.2474 22.061 27.9004 36.367 17.0764 54.5934C16.3083 55.8867 14.6373 56.3125 13.344 55.5445ZM3.18323 124.634C3.53092 126.098 4.99912 127.002 6.46255 126.654C7.92598 126.307 8.83046 124.839 8.48277 123.375C3.58277 102.751 5.37776 81.1024 13.6076 61.5671C14.1915 60.1809 13.5412 58.5838 12.155 57.9998C10.7688 57.4158 9.17172 58.0661 8.58776 59.4523C-0.0912705 80.0541 -1.98424 102.884 3.18323 124.634Z",
    fill: "url(#paint0_radial_127_90142)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_127_90142)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.2374,
    cy: 27.2367,
    r: 8.20104,
    transform: "rotate(0.25 35.2374 27.2367)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.2374,
    cy: 27.2367,
    r: 8.20104,
    transform: "rotate(0.25 35.2374 27.2367)",
    stroke: "#BBDBFE",
    strokeWidth: 5.44706
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_127_90142",
    x: 7.22701,
    y: 9.47781,
    width: 56.0206,
    height: 56.0201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.4171
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4171
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_127_90142"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.2513
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54275
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_127_90142",
    result: "effect2_dropShadow_127_90142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_127_90142",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_127_90142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.06315 127.466) scale(194.927 243.276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570451,
    stopColor: "#92C6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570551,
    stopColor: "#FECC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D8863D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7291B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge2);
export default __webpack_public_path__ + "assets/media/gauge-2.4fe15a61.svg";
export { ForwardRef as ReactComponent };